import { useTranslation } from 'react-i18next';
import { ForgotPasswordForm } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t('auth.forgot.title')} subtitle={t('auth.forgot.subtitle')}>
      <ForgotPasswordForm />
    </AuthLayout>
  );
}
